import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/page-home'
import Cart from '@/components/page-cart'
import OrderHistory from '@/components/page-order-history'
import SupplierApplication from '@/components/page-supplier-application'
import CustomerLogin from '@/components/page-customer-login'
import AccountSetupPage from '@/components/page-account-setup'
import CustomerProfile from '@/components/page-customer-profile'
import NotFound from '@/components/page-404'
import DefaultTemplate from '@/components/template-default'
import AlternateTemplate from '@/components/template-alternate'
import BillboardTemplate from '@/components/template-billboard'
import DrinksPage from '@/components/page-drinks'
import SuppliersPage from '@/components/page-suppliers'
import SupplierDetailsPage from '@/components/page-supplier-details'
import RequestPasswordResetPage from '@/components/page-request-password-reset'
import ResetPasswordPage from '@/components/page-reset-password'
import RegisterReseller from '@/components/page-register-reseller'
import RegisterShopper from '@/components/page-register-shopper'
import ProductPage from '@/components/page-single-product'
import ResellerNotApprove from '@/components/page-reseller-notapprove'
import Restricted from '@/components/page-restricted'

Vue.use(Router)

export default function (store) {
  const router = new Router({
    mode: 'history',
    routes: [
      {
        path: '/login',
        component: AlternateTemplate,
        children: [
          {
            path: '/',
            name: 'login',
            component: CustomerLogin
          },
          {
            path: '/unauthorized',
            name: 'unauthorized',
            component: ResellerNotApprove
          },
          {
            path: '/restricted',
            name: 'restricted',
            component: Restricted
          }
        ]
      },
      {
        path: '/register-reseller',
        component: AlternateTemplate,
        children: [
          {
            path: '/',
            name: 'register-reseller',
            component: RegisterReseller
          }
        ]
      },
      {
        path: '/register-shopper',
        component: AlternateTemplate,
        children: [
          {
            path: '/',
            name: 'register-shopper',
            component: RegisterShopper
          }
        ]
      },
      {
        path: '/partner-with-us',
        component: AlternateTemplate,
        children: [
          {
            path: '/',
            name: 'partner-with-us',
            component: SupplierApplication
          }
        ]
      },
      {
        path: '/accounts',
        component: AlternateTemplate,
        children: [
          {
            path: 'request-reset',
            name: 'request-password-reset',
            props: true,
            component: RequestPasswordResetPage
          },
          {
            path: 'reset',
            name: 'reset-password',
            component: ResetPasswordPage
          }
        ]
      },
      {
        path: '/',
        component: BillboardTemplate,
        children: [
          {
            path: '/',
            name: 'index',
            component: Index
          },
          {
            path: '/stores/:shopCode',
            name: 'store',
            component: SupplierDetailsPage,
            meta: {
              locationRequired: false
            }
          },
          {
            path: '/stores/:shopCode/:productCode',
            component: SupplierDetailsPage,
            meta: {
              locationRequired: false
            }
          }
        ]
      },
      {
        path: '/',
        component: DefaultTemplate,
        children: [
          {
            path: '/drinks',
            name: 'drinks',
            component: DrinksPage,
            meta: {
              locationRequired: false
            }
          },
          {
            path: '/drinks/:shopCode/:productCode',
            name: 'product',
            component: DrinksPage,
            meta: {
              locationRequired: false
            }
          },
          {
            path: '/stores',
            name: 'stores',
            component: SuppliersPage,
            meta: {
              locationRequired: false
            }
          },
          {
            path: '/drink/:shopCode/:productCode/:variantId',
            name: 'singledrink',
            component: ProductPage,
            meta: {
              locationRequired: false
            }
          },
          {
            path: '/account-setup',
            name: 'account-setup',
            component: AccountSetupPage
          },
          {
            path: '/cart',
            name: 'cart',
            component: Cart
          },
          {
            path: '/my-orders',
            name: 'orders',
            component: OrderHistory
          },
          {
            path: '/profile',
            name: 'profile',
            component: CustomerProfile
          }
        ]
      },
      // {
      //   path: '/unauthorized',
      //   name: 'unauthorized',
      //   component: ResellerNotApprove
      // },
      {
        path: '/*',
        name: '404',
        component: NotFound
      }
      // {
      //   path: '/drinks/:productCode',
      //   name: 'singledrink1',
      //   component: ProductPage,
      //   props (route) {
      //     // return { myprop: route.query.myprop }
      //   }
      // }
    ]
  })

  router.beforeEach((to, from, next) => {
    if (!to.path.startsWith(from.path) && !from.path.startsWith(to.path)) {
      window.scrollTo(0, 0)
    }

    if (to.matched.some(route => route.meta.locationRequired)
        && !store.state.cart.location) {
      next({name: 'index'})
    } else {
      next()
    }
    // if(((to.name !== 'login' || to.name !== 'drinks') && !!store.state.auth.user) || (to.name !== 'index' && !!store.state.auth.user)) next({ name: 'unauthorized' })
    // else next()
    if (store.state.auth.user != null) {
      next()
    } else {
      if (to.name === 'index' || to.name === 'login' || to.name === 'register-reseller' || to.name === 'register-shopper' || to.name === 'drinks' || to.name === 'cart' || to.name === 'request-password-reset' || to.name === 'reset-password') {
        next()
      } else {
        next({ name: 'restricted' })
      }
    }
  })

  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js